<template>
  <div class="accEdite">
      <div class="title">
      <div></div>
      账号管理
    </div>
    <div class="main">
      <el-form
        :model="PassModifyForm"
        :rules="rules"
        ref="PassModifyForm"
        label-width="100px"
        class="Accoutadd-Form"
      >
        <el-form-item label="原密码" prop="oldPwd" style="width: 400px">
          <el-input
            type="password"
            v-model="PassModifyForm.oldPwd"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="password" style="width: 400px">
          <el-input
            type="password"
            v-model="PassModifyForm.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="checkPass" style="width: 400px">
          <el-input
            type="password"
            v-model="PassModifyForm.checkPass"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('PassModifyForm')"
            >确定</el-button
          >
          <el-button @click="resetForm('PassModifyForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updatePwd } from "@/api/api.js";
import local from '@/utils/local'

export default {
  data() {
    // 新密码验证
    let reg = /^[a-zA-Z0-9_-]{4,18}$/;
    const checkNewPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("新密码不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("长度在 6 到 15 个字符"));
      } else {
        if (this.PassModifyForm.checkPass !== "") {
          this.$refs.PassModifyForm.validateField("checkPass");
        }
        callback();
      }
    };
    // 确定密码验证
    const checkConfirmPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("确定密码不能为空"));
      } else if (value !== this.PassModifyForm.password) {
        callback(new Error("两次密码不一致"));
      } else callback();
    };
    return {
      PassModifyForm: {
        password: "",
        oldPwd: "",
        checkPass: "",
      },
      rules: {
        oldPwd: [
          { required: true, message: "原密码不能为空", trigger: "blur" },
        ],
        password: [{ required: true, validator: checkNewPwd, trigger: "blur" }],
        checkPass: {
          required: true,
          validator: checkConfirmPwd,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    submitForm(formName) {
      let uid=local.get('id')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code, msg } = await updatePwd({
            oldPWd: this.PassModifyForm.oldPwd,
            password: this.PassModifyForm.password,
            uid: uid,
          });
          if (code == 200) {
            this.$message({
              message: "恭喜你，修改成功，请重新登录",
              type: "success",
            });
            local.clear()
            this.$router.push({ path: "/login" });
          }
        } 
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>


<style lang="less" scoped>
.accEdite {

  height: 100%;
  background: #fff;
    padding: 15px;
  color: #303133;
   .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .main{
    margin-top: 30px;
  }
}
</style>